import React, { useEffect, useState } from "react";
import { api } from "../lib/api";

export function CompanyDashboard({ partnerId }) {
  const [coaches, setCoaches] = useState([]);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  async function load() {
    setLoading(true);
    setError(null);
    try {
      const [cs, st] = await Promise.all([
        api(`/api/partners/${partnerId}/coaches`),
        api(`/api/partners/${partnerId}/stats`),
      ]);
      setCoaches(cs || []);
      setStats(st || null);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    load();
  }, [partnerId]);

  return (
    <div className="max-w-6xl mx-auto p-4 md:p-8">
      <h2 className="text-2xl font-bold mb-4">Company Dashboard</h2>
      {error && <div className="mb-4 rounded-2xl border border-red-200 bg-red-50 p-3 text-red-700">{error}</div>}

      {stats && (
        <div className="rounded-2xl border p-4 mb-6">
          <div className="text-sm">
            Plan: <b>{stats.planName}</b> • Seats: <b>{stats.coachesTotal}/{stats.maxCoaches}</b> • Remaining:{" "}
            <b>{stats.remainingSeats}</b>
          </div>
          <div className="text-sm">
            Status: {stats.isActive ? "Active" : "Inactive"}{" "}
            {stats.currentPeriodEndUtc ? `• Renews: ${new Date(stats.currentPeriodEndUtc).toLocaleDateString()}` : ""}
          </div>
        </div>
      )}

      <div className="rounded-2xl border p-4">
        <h3 className="font-semibold mb-3">Coaches</h3>
        {loading ? (
          <div>Loading…</div>
        ) : (
          <div className="overflow-auto">
            <table className="min-w-full text-sm">
              <thead>
                <tr className="text-left">
                  <th className="py-2 pr-4">ID</th>
                  <th className="py-2 pr-4">Name</th>
                  <th className="py-2 pr-4">Email</th>
                  <th className="py-2 pr-4">Phone</th>
                  <th className="py-2 pr-4">Tier</th>
                  <th className="py-2 pr-4">Status</th>
                </tr>
              </thead>
              <tbody>
                {coaches.map((c) => (
                  <tr key={c.id} className="border-t">
                    <td className="py-2 pr-4">{c.id}</td>
                    <td className="py-2 pr-4">{c.fullName}</td>
                    <td className="py-2 pr-4">{c.email}</td>
                    <td className="py-2 pr-4">{c.phoneNumber}</td>
                    <td className="py-2 pr-4">{c.subscriptionTier}</td>
                    <td className="py-2 pr-4">{c.subscriptionStatus}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
